// extracted by mini-css-extract-plugin
export default {"modalDialog":"ImportTextModal_modalDialog__AVA-g"};